// Story 6.9 (ADO-1163, AC3) — App shell. Header band + centred page container
// with a standard page title/subtitle block (matches the My Account / Admin
// screen headers in Figma 532:2370 / 572:3553).

import type { ReactNode } from 'react';
import styles from './AppShell.module.css';

export interface AppShellProps {
  /** Right-side header slot (search, account, nav icons). */
  actions?: ReactNode;
  /** Page heading (e.g. "My Account", "Admin user management"). */
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AppShell({ actions, title, subtitle, children }: AppShellProps) {
  return (
    <>
      <header className={styles.header}>
        <span className={styles.brand}>ShopLink</span>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </header>
      <main className={styles.main}>
        <h1 className={styles.pageTitle}>{title}</h1>
        {subtitle ? <p className={styles.pageSubtitle}>{subtitle}</p> : null}
        {children}
      </main>
    </>
  );
}
